import { ReduxState } from "ra-core";
import { FC } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import withCompositeResource, { WrappedComponentProps } from "~/components/recource/CompositeResource";
import { OnDataFeature } from "~/gen/api/user";
import { getUserProfile } from "~/reducers/userProfile";

const SecureFileCompositeContent: FC<WrappedComponentProps> = ({
  children,
}) => {
  const [requested, hasSecureFileFeature] = useSelector<ReduxState, [boolean, boolean]>(store => {
    const data = getUserProfile(store)
    return [Boolean(data), Boolean(data?.features?.some(f => f.featureId === OnDataFeature.OnDataSecureFile))] as any
  })

  if (!hasSecureFileFeature) {
    return (
      requested ? <Redirect to="/" /> : null
    )
  }
  return (
    <>{children}</>
  )
}

export const SecureFileComposite = withCompositeResource(SecureFileCompositeContent);
